import { useField } from "formik"
import { useEffect } from "react"
import { getCronTimeUtc } from "./scheduleHelpers"

export default function AssessmentScheduleSingle({
  cronFieldName,
  timeValue,
  refreshCronStatement,
}) {
  const [, , helpers] = useField(cronFieldName)

  useEffect(() => {
    let timeValues = getCronTimeUtc(timeValue)

    //Default cron is week days
    let newCron = `${timeValues} * * *`

    helpers.setValue(newCron)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCronStatement])

  return <></>
}
